import React, { useEffect } from "react";
import styled from "styled-components";

const SizePicker = ({ size, setSize, setFreezeProgress }) => {
  const SIZES_AVAILABLE = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

  useEffect(() => {
    setFreezeProgress(true);
    if (size > 0) {
      setFreezeProgress(false);
    }
  }, [size]);
  return (
    <Picker>
      <p className="title">Size in Kg</p>
      <select
        className="size-input"
        onChange={(e) => setSize(parseInt(e.target.value))}
        value={size}
      >
        <option default hidden>
          Pick a size
        </option>
        {SIZES_AVAILABLE.map((size) => {
          return <option value={size}>{size}</option>;
        })}
      </select>
    </Picker>
  );
};

export default SizePicker;

const Picker = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  .title {
    font-weight: 900;
    font-size: 20px;
    text-align: center;
  }

  .size-input {
    width: 80%;
    height: 40px;
    border: 2px solid;
    border-radius: 10px;
    background: none;
    margin: 0 auto;
  }
`;
